





















import { Component, Vue, Prop } from 'vue-property-decorator';
import { AccountModule } from '@/store/modules/account';
import { requestUpdateComment } from './commentOperation';

type ICommentInfo = IComment.IResponse.ICommentInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;

@Component
export default class CommentEdit extends Vue {
  @Prop({ default: () => false }) private isEdit!: boolean;
  @Prop() private comment!: ICommentInfo;
  @Prop({ default: '' }) private url!: string;
  private commentValue: string = '';
  private submitting: boolean = false;
  // 对外暴露修改submitComment方法
  public changeTheRequestFunctionForSubmitComment(
    fun: (comment: ICreateOrUpdateComment) => Promise<string>,
  ) {
    this.submitComment = fun;
  }
  private created() {
    this.commentValue = this.isEdit ? this.comment.data : '';
  }
  private submitComment(comment: ICreateOrUpdateComment): Promise<string> {
    return new Promise((reslove, reject) => {
      if (!this.url.trim()) {
        reject('no url');
        return;
      }
      requestUpdateComment(this.url, comment)
        .then((res) => {
          reslove(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  private handleSubmit() {
    this.submitting = true;
    const comment: ICreateOrUpdateComment = {
      id: '',
      comment: this.commentValue,
      createdName: AccountModule.name,
    };
    let isCreate = true;
    if (this.comment) {
      isCreate = false;
      comment.id = this.comment.id;
      comment.createdName = this.comment.createdName;
    }
    this.submitComment(comment)
      .then((res) => {
        this.submitting = false;
        this.commentValue = '';
        this.$message.success('Success');
        isCreate ? this.$emit('created', comment) : this.$emit('updated', comment);
      })
      .catch((err) => {
        this.submitting = false;
        this.$message.warning(err);
      });
  }
}
